var React = require('react');

function IconFullscreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M180.1 352.8l-.9-113.7 189.1 189.2c3.9 3.9 10.2 3.9 14.1 0l43.9-43.8c3.9-3.9 3.9-10.2 0-14.2l-189.9-190h106.1c5.5 0 10-4.5 10-10v-62.2c0-5.5-4.5-10-10-10H108c-5.5 0-10 4.5-10 10v234.6c0 5.5 4.5 10 10 10h72.1v.1zm664 0l.9-113.7-189.1 189.1c-3.9 3.9-10.2 3.9-14.1 0l-43.9-43.8c-3.9-3.9-3.9-10.2 0-14.2l189.9-190H681.6c-5.5 0-10-4.5-10-10v-62.1c0-5.5 4.5-10 10-10h234.6c5.5 0 10 4.5 10 10v234.6c0 5.5-4.5 10-10 10h-72.1v.1zM180 683.8l-.8 103.6 189.1-189.2c3.9-3.9 10.2-3.9 14.1 0l43.9 43.8c3.9 3.9 3.9 10.2 0 14.2l-189.9 190h106.1c5.5 0 10 4.5 10 10v62.1c0 5.5-4.5 10-10 10H108c-5.5 0-10-4.5-10-10V683.7c0-5.5 4.5-10 10-10h62c5.6 0 10.1 4.5 10 10.1zm664.1-10.1l.9 113.7-189.1-189.1c-3.9-3.9-10.2-3.9-14.1 0l-44 43.7c-3.9 3.9-3.9 10.2 0 14.2l189.9 190H681.6c-5.5 0-10 4.5-10 10v62.1c0 5.5 4.5 10 10 10h234.6c5.5 0 10-4.5 10-10V683.7c0-5.5-4.5-10-10-10h-72.1z"}));
}

IconFullscreen.displayName = "IconFullscreen";

IconFullscreen.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconFullscreen;

IconFullscreen.default = IconFullscreen;
